import React from "react";
import {Col, ListGroupItem, Row, Table} from "react-bootstrap";
import moment from "moment-timezone";
import {Glyph} from "../common/Glyph";
import {GlobalContext} from "../../GlobalContext";

export class PatientListRow extends React.Component {

    getSbStatusGlyph = (status) => {
        if (!status) {
            return <Glyph name={"ban"} label={"No superbill yet"} style={{fontSize: "2.5rem", color: "#ccc"}}/>
        }
        switch (status) {
            case "NEW":
                return <Glyph name={"pencil-square"} label={"In Progress"} style={{fontSize: "2.5rem", color: "#0483ea"}}/>
            case "SUBMITTED":
                return <Glyph name={"send-check"} label={"Submitted"} style={{fontSize: "2.5rem", color: "#9d04ea"}}/>
            case "COMPLETE":
                return <Glyph name={"check-circle"} label={"Complete"} style={{fontSize: "2.5rem", color: "#278649"}}/>
        }
        return <></>
    }

    authTaskInfo = (p) => {
        let reason = "";
        let timestamp = "";
        let user = p.authTaskAssigneeUsername || "";

        if (p.authTaskStatus == "PENDING" && p.authTaskPendingReason) {
            reason = `(${p.authTaskPendingReason})`;
        }
        if (p.authTaskStatus == "DISMISSED" && p.authTaskClosedReason) {
            reason = `(${p.authTaskClosedReason})`;
        }
        if (p.authTaskStatus == "DISMISSED" || p.authTaskStatus == "COMPLETE") {
            timestamp = moment(p.authTaskClosedAt).format("M/D/YY h:mm A");
        }

        return <Table size={"small"} borderless className={"text-secondary mt-1"}>
            <tbody><tr>
                <td className={"p-0"}><Glyph name={"info-circle"} className={"mr-2"}/></td>
                <td className={"p-0 w-100"}>Auth Task: {p.authTaskStatus} {reason}</td>
            </tr>{
                user ? <tr>
                    <td className={"p-0"}></td>
                    <td className={"p-0"}>{timestamp} {user}</td>
                </tr> : <></>}</tbody>
        </Table>
    }

    render() {
        let p = this.props.patient;
        let apptDate = p.appointmentDateTime ? moment(p.appointmentDateTime).format("YYYY-MM-DD") : "";
        let rules = p.ruleActions || [];
        let ptNameColor = rules.find(r => r.action == "PT_NAME_COLOR")?.param1 || null;

        return <ListGroupItem action href={`/superbill/form?patientId=${p.patientId}&apptDate=${apptDate}`}>
            <Row>
                <Col md={8} lg={9}>
                    <Row>
                        <Col className={"font-weight-bold"} style={{color: ptNameColor}}>{p.firstName} {p.lastName} {p.dob ? moment(p.dob).format("M/D/YY") : ""}</Col>
                        <Col className={"text-right"}>
                            Acct# {p.externalPatientId} {p.externalPatientId2 && ` Pt# ${p.externalPatientId2}`}
                        </Col>
                    </Row>
                    <Row>
                        <Col>Appt: {p.appointmentDateTime ? moment(p.appointmentDateTime).format("M/D/YY h:mm A") : "N/A"}</Col>
                        <Col className={"text-right"}>
                            {p.reasonCodes}
                        </Col>
                    </Row>
                    {(p.printed || p.authTaskId) && <Row>
                        <Col className={"text-secondary"}>
                            {
                                p.authTaskId && this.authTaskInfo(p)
                            }
                        </Col>
                        <Col className={"text-right text-secondary"}>
                            {
                                p.printed &&
                                    <><Glyph name={"printer"} className={"mr-2"}/><small>printed by {p.printedByUsername} {moment(p.printed).format("M/D/YY h:mm A")}</small></>
                            }
                        </Col>
                    </Row>}
                </Col>
                <Col className={"text-center"}>
                    {
                        (p.inLobbyAt || p.superbillStatus == 'SUBMITTED') &&
                            <Glyph name={"person-square"} label={"In Lobby"} showLabelOnClick={false} className={"clickable"} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.props.onToggleInLobby(p.superbillId)
                            }} style={{fontSize: "2.5rem", color: `${p.inLobbyAt ? "#cc0000" : "#ccc"}`}}/>
                    }
                    {
                        p.inLobbyAt && <div className={"text-secondary"}><small>{moment(p.inLobbyAt).format("h:mm A")}</small></div>
                    }
                </Col>
                <Col className={"text-center"}>
                    {this.getSbStatusGlyph(p.superbillStatus)}
                </Col>
            </Row>
        </ListGroupItem>
    }
}